
















import { computed, defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';
import VehiclePopoverCell from '@/components/Comparison/VehiclePopoverCell.vue';
import ComparisonRow from '@/components/Comparison/ComparisonRow.vue';

export default defineComponent({
    name: 'OwnersRow',
    components: { ComparisonRow, VehiclePopoverCell },
    setup () {
        const store = useStore();
        const owners = computed(() => store.getters.visibleValuesOf(store.state.owners));
        const plurals = (word: string, amount: number) => amount === 1 ? word : word + 's';
        return { owners, plurals };
    }
});
